import { Button, Text } from '@/shared/ui'

import cl from './operator-switch.module.scss'

type OperatorSwitchProps = {
	lastUserMessage: string
	goToOperator?: (message: string) => void
}

export const OperatorSwitch = ({ lastUserMessage, goToOperator }: OperatorSwitchProps) => {
	return (
		<div className={cl.operator}>
			<div className={cl.operator__textBlock}>
				<Text weight="semibold">Нужна помощь оператора?</Text>
				<Text size="1">Переключись в любой момент</Text>
			</div>

			<Button className={cl.operator__button} onClick={() => goToOperator?.(lastUserMessage)}>
				К оператору →
			</Button>
		</div>
	)
}
